import React from 'react';
import PageWrapper from '@/components/ui/PageWrapper';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const packages = [
  {
    name: 'Essential Detail',
    price: '149',
    desc: 'Perfect for regular maintenance and keeping your vehicle looking fresh.',
    features: [
      'Foam cannon pre-soak',
      'Two-bucket safe hand wash',
      'Wheel & tire cleaning',
      'Tire dressing applied',
      'Thorough vacuuming',
      'Wipe down of all hard surfaces',
      'Interior/exterior glass cleaning',
      'Spray wax application (1 month)'
    ],
    popular: false
  },
  {
    name: 'Premium Detail',
    price: '249',
    desc: 'Our most popular package. A deep reset for both the interior and exterior.',
    features: [
      'Everything in Essential',
      'Chemical iron decontamination',
      'Clay bar treatment',
      'Premium silica sealant (6 months)',
      'Deep interior vacuum & crevice clean',
      'Leather cleaning & conditioning',
      'Plastics UV protection applied',
      'Exhaust tips polished'
    ],
    popular: true
  },
  {
    name: 'Ultimate Protection',
    price: '699',
    desc: 'The ultimate transformation involving machine polishing and long-term protection.',
    features: [
      'Everything in Premium',
      '1-Step Paint Correction (Gloss enhancement)',
      '1-Year Ceramic Coating on paint',
      'Wheel faces ceramic coated',
      'Windshield glass coating',
      'Hot water carpet extraction',
      'Engine bay detail included',
      'Ozone odor treatment'
    ],
    popular: false
  }
];

const Packages = () => {
  return (
    <PageWrapper>
      <div className="py-24 bg-bgDark relative overflow-hidden">
        {/* Background elements */}
        <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-accent/5 blur-[120px] rounded-full pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-primary/50 blur-[100px] rounded-full pointer-events-none"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-10 text-center mb-16">
          <span className="text-accent text-sm font-bold tracking-widest uppercase mb-2 block">Pricing</span>
          <h1 className="text-5xl md:text-6xl font-heading font-bold mb-6">Detailing Packages</h1>
          <p className="text-xl text-textMuted max-w-2xl mx-auto">
            Transparent pricing for uncompromising quality. Choose the level of care that best suits your vehicle's needs.
          </p>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            {packages.map((pkg, idx) => (
              <motion.div
                key={pkg.name}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.2 }}
                className={`relative rounded-2xl border ${pkg.popular ? 'bg-primary border-accent shadow-[0_0_30px_rgba(212,175,55,0.15)] py-12' : 'bg-secondary/20 border-white/10 py-10'} px-8`}
              >
                {pkg.popular && (
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-accent text-black px-4 py-1 rounded-full text-xs font-bold tracking-wider uppercase">
                    Most Popular
                  </div>
                )}
                
                <h3 className="text-2xl font-heading font-bold mb-2">{pkg.name}</h3>
                <p className="text-sm text-textMuted mb-6 h-10">{pkg.desc}</p>
                
                <div className="mb-8">
                  <span className="text-sm text-textMuted">Starting at</span>
                  <div className="flex items-baseline gap-1 mt-1">
                    <span className="text-2xl font-bold">CA$</span>
                    <span className="text-5xl font-bold font-heading">{pkg.price}</span>
                  </div>
                </div>

                <ul className="space-y-4 mb-10">
                  {pkg.features.map((feature, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <SafeIcon icon={FiIcons.FiCheckCircle} className="text-accent mt-1 flex-shrink-0" />
                      <span className="text-sm text-textLight/90">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link 
                  to="/booking" 
                  className={`w-full block text-center py-4 rounded-md font-medium transition-all ${pkg.popular ? 'bg-accent text-black hover:bg-yellow-500' : 'bg-white/5 text-white hover:bg-white/10 border border-white/10'}`}
                >
                  Select Package
                </Link>
              </motion.div>
            ))}
          </div>
          
          <div className="mt-16 text-center text-textMuted text-sm max-w-2xl mx-auto">
            * Prices shown are starting prices for sedans and small coupes. Mid-size SUVs, large trucks, and heavily soiled vehicles will incur additional charges. Final quote provided upon vehicle inspection.
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Packages;